import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function PainSection() {
  const pains = ['Te acostás y tardás 30, 40, 60 minutos en dormirte — con la mente corriendo a mil', 'Te despertás entre las 2 y las 4 AM sin razón aparente — y no podés volver a dormir', 'Dormís 7-8 horas y igual amanecés destruido — como si no hubieras dormido nada', 'Tomás melatonina, manzanilla, magnesio — sin saber si funciona o cuánto tomar', 'Los fines de semana dormís diferente — y el lunes pagás las consecuencias', 'Tu rendimiento laboral, tu humor y tu energía dependen de una moneda al aire cada noche', 'Mañana a la mañana vas a estar igual — a menos que algo cambie hoy'];
  return <section className="py-24 relative" data-id="element-175">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-12" data-id="element-177">
          <h2 className="text-3xl md:text-5xl font-display font-bold text-white mb-8 text-balance" data-id="element-178">
            ¿Cuántas noches más vas a desperdiciar así?
          </h2>

          <div className="space-y-6 text-lg text-slate-300 text-left md:text-center" data-id="element-179">
            <p data-id="element-180">
              Sos una persona que rinde. Que tiene responsabilidades. Que
              necesita estar al 100%.
            </p>
            <p data-id="element-181">Pero nadie te enseñó cómo funciona realmente tu sueño.</p>
            <p data-id="element-182">
              No es que sos de "dormir mal". No es estrés irresoluble. No es
              genética.
            </p>
            <p className="font-semibold text-white text-xl" data-id="element-183">
              Es que nadie te enseñó el sistema.
            </p>
          </div>
        </motion.div>

        <div className="space-y-4 mb-16" data-id="element-184">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 p-4 rounded-xl bg-red-950/10 border border-red-900/20" data-id="element-185">
              <div className="flex-shrink-0 mt-1 text-red-500" data-id="element-186">
                <X size={20} data-id="element-187" />
              </div>
              <p className="text-slate-300 leading-relaxed" data-id="element-188">{pain}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-189">
          <p className="text-2xl md:text-3xl font-display font-bold text-amber-500 italic" data-id="element-190">
            ¿Y si esta fuera la última noche que pasás así?
          </p>
        </motion.div>
      </div>
    </section>;
}